import { combineReducers } from 'redux';
import { combineEpics } from 'redux-observable';

import { CommonEpic } from 'common/types';

import { modalReducer } from './modal/reducer';
import * as resourcesApi from './resources/api';
import * as resourcesEpics from './resources/epics';
import { resourcesReducer } from './resources/reducer';
import * as userApi from './user/api';
import * as userEpics from './user/epics';
import { userReducer } from './user/reducer';

export const api = { ...userApi, ...resourcesApi };

const commonReducer = combineReducers({
  modal: modalReducer,
  user: userReducer,
  resources: resourcesReducer,
});

const commonEpics: CommonEpic<typeof api> = (action$, state$) =>
  combineEpics(...Object.values(userEpics), ...Object.values(resourcesEpics))(action$, state$, { api });

export default commonEpics;

export { commonReducer, commonEpics };
